export default class FormItem {
  constructor(value, parent) {
    this.__value = null;
    this.__watchers = [];
    this.__component = null;
    this.__disabled = false;
    this.__valided = false;
    this.__error = '';
    this.__old = null;
    this.__focused = false;
    this.__parent = parent;
    this.$el = null;
    this.rules = [];
    this.label = '';
    this.type = '';
    this.name = '';
    this.show = false;
    this.loading = false;
    this.setValue(value);
    this.update();
  }

  get value() {
    return this.get(this.__value);
  }

  set value(value) {
    if (this.disabled) {
      return;
    }
    const oldValue = this.__value;
    const newValue = this.$set(value);
    if (newValue !== oldValue) {
      this.setValue(newValue);
      this.$emit('watch', newValue, oldValue);
    }
  }

  get required() {
    return !!this.rules.find(i => i.required);
  }

  get disabled() {
    return this.__disabled || this.parent.disabled || false;
  }

  set disabled(value) {
    this.__disabled = !!value;
  }

  get parent() {
    return this.__parent || {};
  }

  get() {
    return this.value;
  }

  $set(value) {
    return value;
  }

  setValue(value) {
    this.__value = this.$set(value);
    return this;
  }

  setParameters(parameters = {}) {
    Object.keys(parameters)
      .forEach((attr) => {
        this[attr] = parameters[attr];
      });
    return this;
  }

  $on(type, fn) {
    this.__watchers.push({
      type,
      fn,
    });
    return this;
  }

  $off(fn) {
    this.__watchers = this.__watchers.filter(i => i.fn !== fn);
    return this;
  }

  $watch(type, fn) {
    this.$on.push('watch', fn);
    return this;
  }

  $unwatch(fn) {
    this.$off(fn);
    return this;
  }

  $emit(type, newValue, oldValue) {
    this.__watchers.forEach((i) => {
      if (i.type === type) {
        i.fn(type, newValue, oldValue);
      }
    });
    return this;
  }

  cancel() {
    this.setValue(this.__old);
    this.$emit('cancel');
    return this;
  }

  update(value) {
    this.$emit('update');
    if (typeof value === 'undefined') {
      this.__old = this.value;
    } else {
      this.value = value;
      this.__old = this.value;
    }
    this.$emit('updated');
    return this;
  }

  // Нужно для генерации данных для запроса
  // обязательно нужно возвращать объект
  toData() {
    if (!this.name) {
      return {};
    }
    return {
      [this.name]: this.value,
    };
  }

  toValidate() {
    this.__focused = true;
    if (!this.$el || this.disabled) {
      this.__valided = true;
      return Promise.resolve();
    }
    return this.toValid();
  }

  toValid() {
    return Promise
      .all([
        ...this.rules.map(i => i.validator(this.value)),
      ])
      .then(() => {
        this.__valided = true;
        this.__error = '';
        return Promise.resolve();
      }, (e) => {
        this.__valided = false;
        this.__error = e;
        return Promise.reject(e);
      });
  }

  toReset() {
    this.__focused = false;
    this.__valided = true;
    return this;
  }

  toSubmit() {
    return Promise.resolve(this.toData());
  }

  toString() {
    return `${this.value}`;
  }
}
